export default {"src":"/_next/static/media/NNN.2711d98f.svg","height":18,"width":18};